<div class="video-card">
  <div class="video-header">
    <h2>{{ config().displayName }}</h2>
  </div>
  <div class="video-content">
    <p class="video-type">URL de Video</p>
    <div class="url-input-container">
      <input
        type="text"
        class="video-url-input"
        [value]="videoUrl()"
        (input)="onVideoUrlChange($event)"
        [placeholder]="config().placeholder"
      />
    </div>

    <div class="video-actions">
      <button
        class="primary-button"
        (click)="onUpdate()"
        [disabled]="loading()"
      >
        {{ loading() ? "Actualizando..." : "Actualizar" }}
      </button>
      <button class="primary-button" (click)="onVisualize()">Visualizar</button>
    </div>
  </div>
</div>
